import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';

import { HomePageComponent } from './home/home-page/home-page.component';
import { RedirectMitec2Guard } from './guards/redirect-mitec2.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: HomePageComponent
  },
  {
    path: 'credentials',
    loadChildren: './credentials/credentials.module#CredentialsModule'
  },
  {
    path: 'rrhh',
    loadChildren: './rrhh/rrhh.module#RrhhModule'
  },
  {
    path: 'settings',
    loadChildren: './settings/settings.module#SettingsModule'
  },
  {
    path: 'user',
    loadChildren: './user/user.module#UserModule'
  },
  {
    path: 'titulation',
    loadChildren: './titulation/titulation.module#TitulationModule'
  },
  {
    path: 'graduation',
    canActivate: [RedirectMitec2Guard],
    canActivateChild: [RedirectMitec2Guard],
    loadChildren: './graduation/graduation.module#GraduationModule'
  },
  {
    path: 'inscriptions',
    canActivate: [RedirectMitec2Guard],
    canActivateChild: [RedirectMitec2Guard],
    loadChildren: './inscriptions/inscriptions.module#InscriptionsModule'
  },
  {
    path: 'school-services',
    loadChildren: './school-services/school-services.module#SchoolServicesModule'
  },
  {
    path: 'job-exchange',
    loadChildren: './job-exchange/job-exchange.module#JobExchangeModule'
  },
  {
    path: 'english',
    loadChildren: './english/english.module#EnglishModule'
  },
  {
    path: 'social-service',
    canActivate: [RedirectMitec2Guard],
    canActivateChild: [RedirectMitec2Guard],
    loadChildren: './social-service/social-service.module#SocialServiceModule'
  },
  {
    path: 'schedule',
    loadChildren: './schedule/schedule.module#ScheduleModule'
  },
  {
    path: 'constancies',
    loadChildren: './constancies/constancies.module#ConstanciesModule'
  },
  {
    path: 'badges',
    loadChildren: './badges/badges.module#BadgesModule'
  },
  {
    path: 'receipt',
    loadChildren: './receipts/receipts.module#ReceiptsModule'
  },
  {
    path: 'dropout',
    canActivate: [RedirectMitec2Guard],
    canActivateChild: [RedirectMitec2Guard],
    loadChildren: './dropout/dropout.module#DropoutModule'
  },
  {
    path: 'titulation-bell',
    loadChildren: './titulation-bell/titulation-bell.module#TitulationBellModule'
  },
  {
    path: 'survey',
    loadChildren: './survey/survey.module#SurveyModule'
  },
  {
    path: 'library',
    canActivate: [RedirectMitec2Guard],
    canActivateChild: [RedirectMitec2Guard],
    loadChildren: './library/library.module#LibraryModule'
  },
  {
    path: 'mobility',
    canActivate: [RedirectMitec2Guard],
    canActivateChild: [RedirectMitec2Guard],
    loadChildren: './mobility/mobility.module#MobilityModule'
  },
  {
    path: 'tutorials',
    loadChildren: './tutorials/tutorials.module#TutorialsModule'
  },
  {
    path: 'contracts',
    loadChildren: './contracts/contracts.module#ContractsModule'
  },
  {
    path: '**',
    redirectTo: ''
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: QuicklinkStrategy
    }),
  ],
  exports: [RouterModule]
})

export class AppRoutingModule {

}

